import { useApiClient } from "../../../hooks/useApiClient";
import useSWRImmutable from "swr/immutable";
import {
  type ICommercialImportStatusItem,
  type ICommercialImportStatusResponse,
} from "../types";

interface IUseCommercialImportStatusReturnType {
  importStatuses: ICommercialImportStatusItem[];
  isLoading: boolean;
  isError: boolean;
}

/**
 * 商業登記 インポートステータス（import-status）を取得するカスタムフック
 */
export const useCommercialImportStatus =
  (): IUseCommercialImportStatusReturnType => {
    const { apiClient } = useApiClient();

    const fetcher = async (
      url: string
    ): Promise<ICommercialImportStatusResponse> => {
      const { data } = await apiClient.get<ICommercialImportStatusResponse>(
        url
      );
      return data;
    };

    const { data, error, isLoading } = useSWRImmutable<
      ICommercialImportStatusResponse,
      Error
    >("commercial-reception-book/import-status", fetcher);

    return {
      importStatuses: data?.list ?? [],
      isLoading,
      isError: Boolean(error),
    };
  };
